export const editConstants = {
    EDIT_SUCCESS: 'edit/success',
    EDIT_FAIL: 'edit/fail',
    EDIT_RESET: 'edit/reset'
}